import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { adminActions } from 'features/admin/store/slice';
import { usePerformActionOnSuccess } from 'shared/hooks';
import useGoBack from 'navigation/hooks/useGoBack';
import { SuccessActionTypesEnum } from 'store/SuccessActionTypes.enum';

import BackButton from 'navigation/components/BackButton/BackButton';
import PageTitle from 'shared/components/layout/PageTitle/PageTitle';
import Hl7PatientForm from 'features/admin/components/Hl7PatientForm';

import { FlexBoxColumn, FlexBoxColumnFull, FlexBoxAlign } from 'styles/layout';

const Hl7PatientAddPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { goBack } = useGoBack();

  const onSubmit = React.useCallback(
    (values) => {
      dispatch(adminActions.createHl7Patient(values));
    },
    [dispatch],
  );

  usePerformActionOnSuccess(
    SuccessActionTypesEnum.HL7_PATIENT_CREATED,
    (successAction) => {
      const newId = successAction.payload?.id ?? successAction.payload;
      navigate(`../${newId}`, { replace: true });
    },
  );

  return (
    <FlexBoxColumn height="100%">
      <FlexBoxAlign>
        <BackButton onBack={goBack} />
        <PageTitle>Add HL7 Patient</PageTitle>
      </FlexBoxAlign>

      <FlexBoxColumnFull p={2}>
        <Hl7PatientForm
          initValues={{}}
          onSubmit={onSubmit}
          onCancel={goBack}
        />
      </FlexBoxColumnFull>
    </FlexBoxColumn>
  );
};

export default Hl7PatientAddPage;
